import {Injectable} from '@angular/core';
import {TestConnectionService} from './test-connection.service';
import {RefreshdatabaseService} from './database/refreshdatabase.service';
import {GeneralService} from './general.service';
import {LoadingController} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class RefreshLiveDetailLinesService {
    loading: any;

    constructor(private testConnectionService: TestConnectionService,
                private refreshdatabaseService: RefreshdatabaseService,
                private generalService: GeneralService,
                private loadingController: LoadingController) {
    }

    async refreshLiveDetailLines() {
        try {
            await this.loadingSpinner();
            await this.testConnectionService.pingServer();
            await this.refreshdatabaseService.refreshLiveContractsResource();
            await this.loading.dismiss();
        } catch (e) {
            await this.loading.dismiss();
            await this.generalService.createToast('No connection to the server');
        }
    }

    async loadingSpinner() {
        await this.loadingController.create({
            message: 'Refreshing Live Detail Lines...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
    }
}
